import Flickity from 'flickity'

export default {
  name: 'top-banner',

  componentDidMount () {
    this.flickity = new Flickity(this.el, {
      pageDots: false,
      prevNextButtons: false,
      autoPlay: true,
      wrapAround: true,
      on: {
        ready: () => {
          document.querySelector('.header').style.top = `${this.el.offsetHeight}px`
        },
      },
    })
  },
}
